import React from 'react';
import styled from "styled-components";

const StyledVideo = styled.div`
    display: flex; 
    flex-direction: column;
    img{
        max-width: 100%;
        border-radius: 10px 10px 0px 0px;
    }
    div.cardbody{
        padding: 1em 1em;
    }
    div{
        margin: 0 !important;
    }
    a{
        display: inline;
        font-weight: bold;
    }
    span{
        display: inline;
        font-size:14px;
    }
    border-radius: 10px; 
    border: none;
    box-shadow:
        0 4.5px 3.6px rgba(0, 0, 0, 0.007),
        0 12.5px 10px rgba(0, 0, 0, 0.01),
        0 30.1px 24.1px rgba(0, 0, 0, 0.013),
        0 100px 80px rgba(0, 0, 0, 0.02)
    ;
    
 `
 
 class Video extends React.Component{
    render(){

        /*gets the props*/
        // const content = this.props;
        const { content } = this.props;
        return (
            <StyledVideo className = 'card'>
                <img src ={content.img}></img>

                <div className = 'cardbody'>
                    <div>
                        <a href="#">{content.name} 
                        <span> {content.label}</span></a>
                    </div>
                    <p>{content.desc}</p>
                </div>
            </StyledVideo>   
        );
    }
 }

 export default class VideoCard extends React.Component {
    render() {
      return (
        <Video content = {this.props}></Video>
      );
    }
  }